import React from 'react';
import { Link } from 'react-router-dom';
import PublicNav from '../components/PublicNav';

function LandingPage() {
  const features = [
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      ),
      title: 'Service Mode',
      description: 'One-tap job completion with photos and notes',
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l5.447 2.724A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
        </svg>
      ),
      title: 'Route Optimization',
      description: 'Google Maps integration for efficient routing',
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 11a4 4 0 100-8 4 4 0 000 8zM23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
        </svg>
      ),
      title: 'Customer Management',
      description: 'Track customers, properties, and service history',
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 1v22M17 5H9.5a3.5 3.5 0 100 7h5a3.5 3.5 0 010 7H6" />
        </svg>
      ),
      title: 'Payment Tracking',
      description: 'Know who paid and who owes at a glance',
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      ),
      title: 'Scheduling',
      description: 'Weekly, bi-weekly, or custom service schedules',
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
          <path d="M12 18h.01" />
        </svg>
      ),
      title: 'Mobile PWA',
      description: 'Works on any device, install like an app',
    },
  ];

  return (
    <div className="landing-page">
      <PublicNav />

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-bg"></div>
        <div className="hero-content">
          <h1 className="hero-title">
            Manage Your Lawn Care Business Like a Pro
          </h1>
          <p className="hero-subtitle">
            Route optimization, customer management, payment tracking — all from your phone
          </p>
          <div className="hero-buttons">
            <Link to="/register" className="btn-hero-primary">
              Start Free Trial
            </Link>
            <Link to="/pricing" className="btn-hero-secondary">
              View Pricing
            </Link>
          </div>
        </div>
        <div className="hero-grass">
          {[...Array(30)].map((_, i) => (
            <div key={i} className="grass-blade" style={{
              left: `${(i / 30) * 100}%`,
              height: `${20 + Math.random() * 30}px`,
              animationDelay: `${Math.random() * 2}s`,
            }}></div>
          ))}
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="features-container">
          <h2 className="features-title">Everything You Need to Run Your Business</h2>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-icon">{feature.icon}</div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SnowTrack - Winter Solution */}
      <section className="snowtrack-section">
        <div className="snowtrack-container">
          <div className="snowtrack-badge">Sister Product</div>
          <div className="snowtrack-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 2v20M2 12h20M4.93 4.93l14.14 14.14M19.07 4.93L4.93 19.07" />
            </svg>
          </div>
          <h2 className="snowtrack-title">SnowTrack™</h2>
          <p className="snowtrack-subtitle">The same powerful features for snow removal</p>
          <p className="snowtrack-description">
            Manage your snow plowing routes, customers, and payments during the winter months.
            One account, year-round coverage.
          </p>
          <a href="https://snowtrack.pro" className="btn-snowtrack" target="_blank" rel="noopener noreferrer">
            Visit SnowTrack
          </a>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-container">
          <h2 className="cta-title">Start Your Free Trial Today</h2>
          <p className="cta-subtitle">No credit card required. See how LawnTrack can transform your business.</p>
          <div className="cta-buttons">
            <Link to="/register" className="btn-cta-primary">
              Start Free Trial
            </Link>
          </div>
          <Link to="/pricing" className="cta-link">
            View Full Pricing & Features →
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="landing-footer">
        <div className="footer-container">
          <div className="footer-brand">
            <span className="footer-logo">LawnTrack™</span>
          </div>
          <div className="footer-links">
            <Link to="/pricing">Pricing</Link>
            <Link to="/login">Login</Link>
            <Link to="/register">Register</Link>
          </div>
          <div className="footer-copyright">
            © 2026 LawnTrack™. All rights reserved.
          </div>
        </div>
      </footer>

      <style>{`
        .landing-page {
          min-height: 100vh;
          background: #f8fafc;
        }

        /* Navigation */
        .landing-nav {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(10px);
          z-index: 100;
          border-bottom: 1px solid #e2e8f0;
        }

        .nav-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 16px 24px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .nav-logo {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 1.5rem;
          font-weight: 700;
          color: #4CAF50;
          text-decoration: none;
        }

        .logo-icon {
          width: 32px;
          height: 32px;
        }

        .nav-links {
          display: flex;
          align-items: center;
          gap: 24px;
        }

        .nav-link {
          color: #475569;
          text-decoration: none;
          font-weight: 500;
          transition: color 0.2s;
        }

        .nav-link:hover {
          color: #4CAF50;
        }

        .nav-btn-primary {
          background: #4CAF50;
          color: white;
          padding: 10px 20px;
          border-radius: 8px;
          text-decoration: none;
          font-weight: 600;
          transition: background 0.2s;
        }

        .nav-btn-primary:hover {
          background: #388E3C;
        }

        /* Hero Section */
        .hero-section {
          position: relative;
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 120px 24px 80px;
          overflow: hidden;
        }

        .hero-bg {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(135deg, #4CAF50 0%, #388E3C 50%, #2E7D32 100%);
          z-index: 0;
        }

        .hero-content {
          position: relative;
          z-index: 2;
          text-align: center;
          max-width: 800px;
        }

        .hero-title {
          font-size: 3rem;
          font-weight: 800;
          color: white;
          margin: 0 0 24px 0;
          line-height: 1.2;
          text-shadow: 0 2px 4px rgba(0,0,0,0.1);
        }

        .hero-subtitle {
          font-size: 1.25rem;
          color: rgba(255, 255, 255, 0.9);
          margin: 0 0 40px 0;
          line-height: 1.6;
        }

        .hero-buttons {
          display: flex;
          gap: 16px;
          justify-content: center;
          flex-wrap: wrap;
        }

        .btn-hero-primary {
          background: white;
          color: #4CAF50;
          padding: 16px 32px;
          border-radius: 10px;
          text-decoration: none;
          font-weight: 700;
          font-size: 1.1rem;
          transition: transform 0.2s, box-shadow 0.2s;
          box-shadow: 0 4px 14px rgba(0,0,0,0.15);
        }

        .btn-hero-primary:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(0,0,0,0.2);
        }

        .btn-hero-secondary {
          background: transparent;
          color: white;
          padding: 16px 32px;
          border-radius: 10px;
          text-decoration: none;
          font-weight: 600;
          font-size: 1.1rem;
          border: 2px solid rgba(255,255,255,0.5);
          transition: background 0.2s, border-color 0.2s;
        }

        .btn-hero-secondary:hover {
          background: rgba(255,255,255,0.1);
          border-color: white;
        }

        /* Grass Animation */
        .hero-grass {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 60px;
          z-index: 1;
          pointer-events: none;
        }

        .grass-blade {
          position: absolute;
          bottom: 0;
          width: 4px;
          background: linear-gradient(to top, #2E7D32, #66BB6A);
          border-radius: 2px 2px 0 0;
          transform-origin: bottom center;
          animation: sway 3s ease-in-out infinite;
        }

        @keyframes sway {
          0%, 100% { transform: rotate(-5deg); }
          50% { transform: rotate(5deg); }
        }

        /* Features Section */
        .features-section {
          padding: 80px 24px;
          background: white;
        }

        .features-container {
          max-width: 1200px;
          margin: 0 auto;
        }

        .features-title {
          text-align: center;
          font-size: 2rem;
          font-weight: 700;
          color: #1e293b;
          margin: 0 0 48px 0;
        }

        .features-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 32px;
        }

        .feature-card {
          padding: 32px;
          background: #f8fafc;
          border-radius: 16px;
          text-align: center;
          transition: transform 0.2s, box-shadow 0.2s;
        }

        .feature-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 12px 24px rgba(0,0,0,0.08);
        }

        .feature-icon {
          width: 56px;
          height: 56px;
          margin: 0 auto 20px;
          background: #E8F5E9;
          border-radius: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #4CAF50;
        }

        .feature-icon svg {
          width: 28px;
          height: 28px;
        }

        .feature-title {
          font-size: 1.25rem;
          font-weight: 600;
          color: #1e293b;
          margin: 0 0 12px 0;
        }

        .feature-description {
          font-size: 0.95rem;
          color: #64748b;
          margin: 0;
          line-height: 1.5;
        }

        /* SnowTrack Section */
        .snowtrack-section {
          padding: 80px 24px;
          background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%);
        }

        .snowtrack-container {
          max-width: 600px;
          margin: 0 auto;
          text-align: center;
        }

        .snowtrack-badge {
          display: inline-block;
          background: #1e88e5;
          color: white;
          padding: 6px 16px;
          border-radius: 20px;
          font-size: 0.85rem;
          font-weight: 600;
          margin-bottom: 24px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .snowtrack-icon {
          width: 72px;
          height: 72px;
          margin: 0 auto 20px;
          background: #bbdefb;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #1e88e5;
        }

        .snowtrack-icon svg {
          width: 36px;
          height: 36px;
        }

        .snowtrack-title {
          font-size: 2rem;
          font-weight: 700;
          color: #0d47a1;
          margin: 0 0 12px 0;
        }

        .snowtrack-subtitle {
          font-size: 1.15rem;
          color: #1565c0;
          margin: 0 0 16px 0;
          font-weight: 500;
        }

        .snowtrack-description {
          font-size: 1rem;
          color: #1976d2;
          margin: 0 0 28px 0;
          line-height: 1.6;
        }

        .btn-snowtrack {
          display: inline-block;
          background: #1e88e5;
          color: white;
          padding: 14px 32px;
          border-radius: 10px;
          text-decoration: none;
          font-weight: 600;
          font-size: 1rem;
          transition: background 0.2s, transform 0.2s;
          box-shadow: 0 4px 14px rgba(30, 136, 229, 0.3);
        }

        .btn-snowtrack:hover {
          background: #1565c0;
          transform: translateY(-2px);
        }

        /* CTA Section */
        .cta-section {
          padding: 80px 24px;
          background: linear-gradient(135deg, #E8F5E9 0%, #C8E6C9 100%);
        }

        .cta-container {
          max-width: 600px;
          margin: 0 auto;
          text-align: center;
        }

        .cta-title {
          font-size: 2rem;
          font-weight: 700;
          color: #1e293b;
          margin: 0 0 16px 0;
        }

        .cta-subtitle {
          font-size: 1.1rem;
          color: #64748b;
          margin: 0 0 32px 0;
        }

        .cta-buttons {
          margin-bottom: 24px;
        }

        .btn-cta-primary {
          display: inline-block;
          background: #4CAF50;
          color: white;
          padding: 16px 40px;
          border-radius: 10px;
          text-decoration: none;
          font-weight: 700;
          font-size: 1.1rem;
          transition: background 0.2s, transform 0.2s;
          box-shadow: 0 4px 14px rgba(76, 175, 80, 0.3);
        }

        .btn-cta-primary:hover {
          background: #388E3C;
          transform: translateY(-2px);
        }

        .cta-link {
          color: #4CAF50;
          text-decoration: none;
          font-weight: 500;
          transition: color 0.2s;
        }

        .cta-link:hover {
          color: #388E3C;
        }

        /* Footer */
        .landing-footer {
          background: #1e293b;
          padding: 48px 24px;
        }

        .footer-container {
          max-width: 1200px;
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 24px;
        }

        .footer-logo {
          font-size: 1.25rem;
          font-weight: 700;
          color: white;
        }

        .footer-links {
          display: flex;
          gap: 32px;
        }

        .footer-links a {
          color: #94a3b8;
          text-decoration: none;
          transition: color 0.2s;
        }

        .footer-links a:hover {
          color: white;
        }

        .footer-copyright {
          color: #64748b;
          font-size: 0.875rem;
        }

        /* Mobile Responsive */
        @media (max-width: 768px) {
          .nav-links {
            gap: 16px;
          }

          .nav-link {
            display: none;
          }

          .hero-title {
            font-size: 2rem;
          }

          .hero-subtitle {
            font-size: 1rem;
          }

          .hero-buttons {
            flex-direction: column;
            align-items: center;
          }

          .btn-hero-primary,
          .btn-hero-secondary {
            width: 100%;
            max-width: 280px;
            text-align: center;
          }

          .features-grid {
            grid-template-columns: 1fr;
          }

          .feature-card {
            padding: 24px;
          }

          .cta-title {
            font-size: 1.5rem;
          }

          .footer-links {
            gap: 24px;
          }
        }
      `}</style>
    </div>
  );
}

export default LandingPage;
